function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M43.45 6H4.55A4.55 4.55 0 000 10.55v27.6a4.55 4.55 0 004.55 4.55h38.9A4.55 4.55 0 0048 38.15v-27.6A4.55 4.55 0 0043.45 6zM4.55 8.4h38.9a2.13 2.13 0 012.13 2.14v3.3H2.38v-3.29A2.13 2.13 0 014.55 8.4zm38.9 31.9H4.55a2.13 2.13 0 01-2.13-2.13V21.15h43.2v17a2.13 2.13 0 01-2.17 2.15z"
})));